function dropzoneTranslations() {
  let t = window.INITIAL_DATA.TRANSLATIONS;
  return {
    dictDefaultMessage: t.dropzone_DefaultMessage,
    dictFallbackMessage: t.dropzone_FallbackMessage,
    dictFallbackText: t.dropzone_FallbackText,
    dictFileTooBig: t.dropzone_FileTooBig,
    dictInvalidFileType: t.dropzone_InvalidFileType,
    dictResponseError: t.dropzone_ResponseError,
    // dictCancelUpload: t.dropzone_CancelUpload,
    dictCancelUpload: "&#10005;",
    dictUploadCanceled: t.dropzone_UploadCanceled,
    dictCancelUploadConfirmation: t.dropzone_CancelUploadConfirmation,
    // dictRemoveFile: t.dropzone_RemoveFile,
    dictRemoveFile: "&#10005;",
    dictRemoveFileConfirmation: t.dropzone_RemoveFileConfirmation,
    dictMaxFilesExceeded: t.dropzone_MaxFilesExceeded,
    // dictFileSizeUnits: t.dropzone_FileSizeUnits,
  };
}

export default dropzoneTranslations;
